Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = exports.ContextualBadge = void 0;
var Tag_1 = require("./Tag");
Object.defineProperty(exports, "ContextualBadge", { enumerable: true, get: function () { return Tag_1.ContextualBadge; } });
Object.defineProperty(exports, "Tag", { enumerable: true, get: function () { return Tag_1.Tag; } });
exports.default = Tag_1.Tag;
//# sourceMappingURL=index.js.map